import React, { useState } from 'react';
import { useRouter } from 'next/router';
// import { useInView } from 'react-intersection-observer';
import useAnimation from 'components/onboard/hooks/useAnimation';
import useMediaQuery from 'lib/hooks/useMediaQuery';
import type { Dayjs } from 'dayjs';
import type { WebsiteDatePublicPropType } from 'util/websiteDateUtil';
import type { WPublicNavItemView } from '@zola/svc-web-api-ts-client';
import type { NavigationMenuProps } from './NavigationMenu/NavigationMenu';
import MobileHeader from './MobileHeader';
import DesktopHeader from './DesktopHeader';

type HeaderProps = Omit<NavigationMenuProps, 'topOffset' | 'isAnimating'> & {
  title?: string;
  city?: string;
  stateProvince?: string;
  websiteDate?: WebsiteDatePublicPropType<Dayjs>;
};

/**
 * Handles conditionally showing the top content, including nav
 * - desktop or mobile
 * - not showing if only one page
 */
const Header = ({
  title,
  navItems,
  slug,
  city,
  stateProvince,
  websiteDate,
}: HeaderProps): JSX.Element | null => {
  const router = useRouter();
  const { preview_type } = router?.query || {};
  const isMobileScreenSize = useMediaQuery(768);
  const [bannerHeight, setBannerHeight] = useState(0);
  const { isAnimating, onAnimationFinish } = useAnimation(0, 1000);
  const setBannerHeightCallback = (height: number) => setBannerHeight(height);
  const showCart =
    (navItems || []).filter(
      n => n.type === (('REGISTRY' as unknown) as WPublicNavItemView.TypeEnum)
    ).length > 0;

  // TODO: IF TIME, LOOK INTO CONDITIONALLY RETURNING BASED ON INTERSECTION OBSERVER INSTEAD OF FIXED SCREEN SIZE
  // const inViewResponse = useInView({ threshold: 1 });
  // const { entry, ref } = inViewResponse;
  // const { intersectionRatio = 0 } = entry || {};
  // if (intersectionRatio < 1 && !showMobileNav) {
  //   setShowMobileNav(true);
  // }
  // if (intersectionRatio === 1 && showMobileNav) {
  //   setShowMobileNav(false);
  // }
  // console.log(showMobileNav);

  if ((preview_type as string | undefined)?.toUpperCase() === 'SCREENSHOT') return null;

  if (isMobileScreenSize) {
    return (
      <MobileHeader
        navItems={navItems}
        slug={slug}
        title={title}
        city={city}
        stateProvince={stateProvince}
        websiteDate={websiteDate}
        bannerHeight={bannerHeight}
        isAnimating={isAnimating}
        onAnimationFinish={onAnimationFinish}
        setBannerHeight={setBannerHeightCallback}
        showCart={showCart}
      />
    );
  }

  return (
    <DesktopHeader
      navItems={navItems}
      slug={slug}
      title={title}
      bannerHeight={bannerHeight}
      isAnimating={isAnimating}
      onAnimationFinish={onAnimationFinish}
      setBannerHeight={setBannerHeightCallback}
      showCart={showCart}
    />
  );
};

export default Header;
